import React from 'react';
import PropTypes from 'prop-types';

export const SelectLabel = ({text}) => {
    return (
        <div className="select-label">
            <span>{text}</span>
        </div>
    )
};

SelectLabel.propTypes = () => ({
    text: PropTypes.string,
});
